<div class="modal-header">
  <h2 class="modal-title">
    {{ 'courseModule.courseSale' | translate }}
  </h2>
  <button
    type="button"
    class="btn-close"
    attr.aria-label="{{ 'general.close' | translate }}"
    (click)="cancel()"
  ></button>
</div>

<div class="modal-body">
  <dms-table
    [isLoading]="isLoading$ | async"
    [showTotal]="true"
    [tableType]="'courses'"
    (onClickRow)="onClickRow($event)"
  >
  </dms-table>
</div>
